import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Outlet } from "react-router-dom";
import "./css/AdminLayout.css";


const AdminLayout = () => {
  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <Sidebar />

      {/* Right Side Layout */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div className="header-wrapper">
          <Header />
        </div>

        {/* Main Content */}
        <main
          style={{
            flex: 1,
            padding: "20px",
            overflowY: "auto",
          }}
        >
          <Outlet />
        </main>

        {/* Footer */}
        <div className="footer-wrapper">
          <Footer />
        </div>
      </div>

      {/* Responsive CSS */}
      <style>
        {`
          @media (min-width: 1300px) {
            .header-wrapper,
            .footer-wrapper {
              margin-left: 22.5%;
            }
          }
          
          @media (min-width: 1100px) and (max-width: 1299px) {
            .header-wrapper,
            .footer-wrapper {
              margin-left: 23%;
            }
          }
          
          @media (max-width: 1099px) {
            .header-wrapper,
            .footer-wrapper {
              margin-left: 31%;
            }
          }
          
          @media (max-width: 900px) {
            .header-wrapper,
            .footer-wrapper {
              margin-left: 0%;
            }
          }           
        `}
      </style>
    </div>
  );
};

export default AdminLayout;
